import { render, staticRenderFns } from "./productSalesPriceConfig.vue?vue&type=template&id=5d1999e2&scoped=true"
import script from "./productSalesPriceConfig.vue?vue&type=script&lang=js"
export * from "./productSalesPriceConfig.vue?vue&type=script&lang=js"
import style0 from "./productSalesPriceConfig.vue?vue&type=style&index=0&id=5d1999e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1999e2",
  null
  
)

export default component.exports